<template>
    <div class="vue-occasions-overview-step-one">
        <slot v-if="loading"></slot>

        <template v-if="hasFilters === true">
            <section class="filter-wrapper">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">
                            <p class="dropdown-label">Merk</p>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Merk" :options="filters.field_merk" filter-key="field_merk"></occasion-dropdown-filter>

                            <p class="dropdown-label">Model</p>
                            <occasion-dropdown-filter :disabled="! showModelDropdown" :event-bus="eventBus" label="name" placeholder="Model" :options="filters.field_model" filter-key="field_model"></occasion-dropdown-filter>
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <template v-if="filters.field_kilometerstand.min !== filters.field_kilometerstand.max">
                                <p class="dropdown-label">Kilometerstand</p>
                                <occasion-dropdown-range-filter
                                    :event-bus="eventBus"
                                    :step.number="10000"
                                    :min="filters.field_kilometerstand.min"
                                    :max="filters.field_kilometerstand.max"
                                    placeholder="Van"
                                    suffix=" km"
                                    filter-key="field_kilometerstand"
                                ></occasion-dropdown-range-filter>
                            </template>

                            <template v-if="filters.field_prijs.min !== filters.field_prijs.max">
                                <p class="dropdown-label">Prijs</p>
                                <occasion-dropdown-range-filter
                                    :event-bus="eventBus"
                                    :step.number="5000"
                                    :min="filters.field_prijs.min"
                                    :max="filters.field_prijs.max"
                                    prefix="€ "
                                    placeholder="Van"
                                    filter-key="field_prijs"
                                ></occasion-dropdown-range-filter>
                            </template>
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <template v-if="filters.field_bouwjaar.min !== filters.field_bouwjaar.max">
                                <p class="dropdown-label">Bouwjaar</p>
                                <occasion-dropdown-range-filter
                                    :event-bus="eventBus"
                                    :step.number="1"
                                    :min="filters.field_bouwjaar.min"
                                    :max="filters.field_bouwjaar.max"
                                    filter-key="field_bouwjaar"
                                    placeholder="Van"
                                    :reverse-range="true"
                                ></occasion-dropdown-range-filter>
                            </template>

                            <template v-if="filters.field_brandstof.length > 1">
                                <p class="dropdown-label">Brandstof</p>
                                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Brandstof" :options="filters.field_brandstof" filter-key="field_brandstof"></occasion-dropdown-filter>
                            </template>
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <template v-if="filters.field_transmissie.length > 1">
                                <p class="dropdown-label">Transmissie</p>
                                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Transmissie" :options="filters.field_transmissie" filter-key="field_transmissie"></occasion-dropdown-filter>
                            </template>

                            <template v-if="filters.field_carrosserie.length > 1">
                                <p class="dropdown-label">Carrosserie</p>
                                <occasion-dropdown-filter :event-bus="eventBus" placeholder="Carrosserie" :options="filters.field_carrosserie" filter-key="field_carrosserie"></occasion-dropdown-filter>
                            </template>
                        </div>
                    </div>

                    <div class="row" :class="{'overflow-unset': showExtraFilters}" v-show-slide="showExtraFilters && hasExtraOptions">
                        <div class="col-md-6 col-lg-3" v-if="filters.field_basiskleur.length > 1">
                            <p class="dropdown-label">Kleur</p>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Kleur" :options="filters.field_basiskleur" filter-key="field_basiskleur"></occasion-dropdown-filter>
                        </div>

                        <div class="col-md-6 col-lg-3" v-if="filters.field_aantal_deuren.length > 1">
                            <p class="dropdown-label">Aantal deuren</p>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Aantal deuren" :options="filters.field_aantal_deuren" filter-key="field_aantal_deuren"></occasion-dropdown-filter>
                        </div>

                        <div class="col-md-6 col-lg-3" v-if="filters.field_aantal_cilinders.length > 1">
                            <p class="dropdown-label">Aantal cilinders</p>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Aantal cilinders" :options="filters.field_aantal_cilinders" filter-key="field_aantal_cilinders"></occasion-dropdown-filter>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 text-center mt-5">
                            <a href="#" v-if="hasExtraOptions" @click.prevent="showExtraFilters = ! showExtraFilters" class="advanced-search mr-md-5">Uitgebreid zoeken</a>

                            <a href="/occasions/resultaat" class="btn-arrow mt-3 mt-sm-0">{{ resultText }}</a>
                        </div>
                    </div>
                </div>
            </section>
        </template>

        <div class="container mt-5">
            <div class="row">
                <div class="col-md-10 mx-auto">
                    <occasion-list-item v-for="(item, index) in items" :key="`occasion-${index}`" :item="item"></occasion-list-item>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import occasionOverviewMixin from '../mixins/occasionOverviewMixin';

export default {
    name: "OccasionOverviewStepOne",

    mixins: [occasionOverviewMixin],

    data() {
        return {
            showExtraFilters: false,
            loading: true,
        }
    },

    computed: {
        hasExtraOptions() {
            return this.filters.field_basiskleur.length > 1
                || this.filters.field_aantal_deuren.length > 1
                || this.filters.field_aantal_cilinders.length > 1
        },

        resultText() {
            if ( this.meta.items > 1 ) {
                return `Toon ${this.meta.items} resultaten`
            }

            return `Toon ${this.meta.items} resultaat`
        }
    },

    mounted() {
        this.appliedFilters = [];
        this.fetchData(true);
    },

    methods: {
        fetchData(loadItems = false) {
            axios.get('/api/occasions', {
                params: {
                    filters: JSON.stringify(this.appliedFilters),
                    page: 1,
                    sort: this.sort
                }
            }).then( response => {
                if (loadItems) {
                    this.items = response.data.data;
                }

                this.filters = response.data.filters;
                this.meta = response.data.meta;
            }).catch(error => {
                console.log(error);
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>